import React from "react";

export default function AboutMe() {
  return (<section>   <div
    id="about"
    className=" container  mx-auto py-16 px-4"
  >   <h2 className="h1 font-semibold mb-10">
    ОБО МНЕ
  </h2>

    <div className="flex text3 flex-col md:flex-row items-center md:items-start gap-10">
      {/* Фото */}
      <div className="w-1/3 flex-shrink-0">
        <img
          src="photo.webp"
          alt="Лапшина Ирина Анатольевна"
          className=" h-auto object-cover rounded-2xl shadow-lg"
        />
      </div>

      {/* Текст */}
      <article className="flex-1 leading-relaxed space-y-4 text-gray-100">
        <h3 className="h2 font-semibold">
          Лапшина Ирина Анатольевна
        </h3>

        <p>
          <strong>Образование:</strong><br />
          Российский государственный социальный университет, 2003 г.
        </p>

        <p>
          Я практикующий юрист с более чем 21-летним опытом работы в крупных государственных и частных организациях.
          С 2014 года занимаюсь частной юридической практикой и специализируюсь на гражданско-правовых спорах
          в сфере жилищного, земельного, семейного, наследственного и иных отраслей права.
          Оказываю помощь в защите прав потребителей, решении страховых споров, приватизации и приобретении недвижимости,
          а также в других юридических вопросах.
        </p>

        <p>
          Моя цель — действительно решать вашу проблему, а не просто представлять вас в суде или консультировать.
          Для меня важны все дела, потому что если это важно для вас — значит, это важно и для меня.
          Я не могу гарантировать стопроцентную победу в суде, но обещаю честность, порядочность,
          конфиденциальность и индивидуальный подход.
        </p>

        <p>
          Моя задача — профессионально защитить ваши интересы и достичь наилучшего результата
          при разрешении вашей проблемы, чему способствует мой многолетний опыт судебной практики.
        </p>

        <p className="pt-4 italic text-gray-300">
          С уважением, <br />
          <span className="not-italic">Лапшина Ирина Анатольевна</span>
        </p>
      </article>
    </div>

    {/* Статистика */}
    <div className="flex flex-col sm:flex-row justify-start gap-6 mt-12">
      <div className="flex items-center gap-3 bg-[#2C3543] py-4 px-6 rounded-full shadow-md">
        <div className="text-3xl">📝</div>
        <div>
          <p className="text2 font-semibold">95%</p>
          <p className="text2 text-gray-300">Успех дела</p>
        </div>
      </div>

      <div className="flex items-center gap-3 bg-white text-[#1F2732] py-4 px-6 rounded-full shadow-md">
        <div className="text-3xl text-white bg-black p-3 rounded-4xl">21+</div>
        <div>
          {/*<p className="text2 font-semibold"></p>*/}
          <p className="text2 text-gray-600">Лет опыта</p>
        </div>
      </div>
    </div>

  </div></section>

  );
}
